<template>
  <v-card
    style="margin-top:25px; min-width: 305px;"
  >
    <v-card-text>Please enter and verify your new password.  The password must be 12 characters or longer.</v-card-text>
    <v-flex xs12 style="padding:0 10px 0 10px">
      <v-text-field
        label="New Password"
        outlined
        v-model="password"
        type="password"
        v-on:keyup.enter="onEnter"
      >
      </v-text-field>
      <v-text-field
        label="Verify New Password"
        outlined
        v-model="verifyPassword"
        type="password"
        v-on:keyup.enter="onEnter"
      >
      </v-text-field>
    </v-flex>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn :disabled="setNewPasswordDisabled" :loading="busy" text @click="setNewPassword">SET PASSWORD</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'PasswordResetForm',

  data() {
    return {
      form: {
        password: '',
        verifyPassword: '',
      },
    };
  },

  computed: {
    password: {
      get() {
        return this.form.password;
      },
      set(value) {
        this.form.password = value;

        this.$emit('passwordChanged', this.form.password);
      },
    },
    verifyPassword: {
      get() {
        return this.form.verifyPassword;
      },
      set(value) {
        this.form.verifyPassword = value;

        this.$emit('passwordChanged', this.form.password);
      },
    },
    setNewPasswordDisabled() {
      return this.password.length === 0 || this.password.length < 12 || this.password !== this.verifyPassword;
    },
  },

  methods: {
    onEnter() {
      this.setNewPassword();
    },
  },

  props: {
    setNewPassword: Function,
    busy: Boolean,
  },
};
</script>

<style scoped>
/* Sets background hero image */
.heroDash {

  width: 100%;
  height: 100%;
}
#accountIconContainer {
  text-align: center !important;
  background-color: #42A5F5;
}

#accountIcon {
  color: black;
  font-size: 128pt;
}

</style>
